import { base } from '../base';

export const baseODATA = 'gateway/mainodata';

export const whatsAppTemplate = `${base}/whatsAppTemplate`;
export const getWhatsAppTemplateODATA = `${baseODATA}/whatsapptemplatesearchquery`;
